module.exports = __webpack_public_path__ + "static/img/about2.f7f04e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/about2.jpg
// module id = eHI7
// module chunks = 3